module.exports = __webpack_public_path__ + "img/icon-calendar.f512ab15.svg";